import { LitElement, html, css } from '@hh/global.js'

class HHCheckboxWrapper extends LitElement {
  static properties = {
    checked: {
      reflect: true,
    },
  }

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
    this.checked = this.querySelector('input')?.checked
  }

  onChange(e) {
    this.checked = e?.target?.checked
  }

  render() {
    return html`
      <div class="checkbox-wrapper">
        <slot @change="${this.onChange}" name="input"></slot>
        <slot name="label"></slot>
        <slot name="checkmark"></slot>
        <slot name="error"></slot>
      </div>
    `
  }

  static styles = css`
    :host {
      display: block;
    }

    .checkbox-wrapper {
      display: flex;
      align-items: var(--align-items, 'center');
      gap: var(--hh-space-2xs);
    }

    ::slotted(input[type='checkbox']) {
      -webkit-appearance: none;
      background-color: var(--hh-color-light, #f6f6f6);
      border: 1px solid var(--hh-color-neutral-ada, #949494);
      width: var(--hh-space-xs, 10px);
      height: var(--hh-space-xs, 10px);
      cursor: pointer;
      display: inline-block;
      box-sizing: border-box;
      flex-shrink: 0;
      margin-top: var(--margin-top, 0px);
    }

    ::slotted(input[type='checkbox']:checked) {
      background-color: #000;
      border-color: #000;
    }
  `
}

customElements.define('hh-checkbox-wrapper', HHCheckboxWrapper)
